const DrivingIcon = ({ height = '50px', width = '50px' }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 50 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M24.9999 44.0813C35.2621 44.0813 43.5812 35.7621 43.5812 25.5C43.5812 15.2379 35.2621 6.91876 24.9999 6.91876C14.7378 6.91876 6.4187 15.2379 6.4187 25.5C6.4187 35.7621 14.7378 44.0813 24.9999 44.0813Z"
      fill="#9190AC"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.0001 39.5406C32.7545 39.5406 39.0407 33.2544 39.0407 25.5C39.0407 17.7456 32.7545 11.4594 25.0001 11.4594C17.2457 11.4594 10.9595 17.7456 10.9595 25.5C10.9595 33.2544 17.2457 39.5406 25.0001 39.5406Z"
      fill="white"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M39 27.5C39 27.5 35.2008 18.5 25 18.5C14.7992 18.5 11 27.5 11 27.5"
      fill="#B5D0EE"
    />
    <path
      d="M39 27.5C39 27.5 35.2008 18.5 25 18.5C14.7992 18.5 11 27.5 11 27.5"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M25.275 24.8C26.1172 24.8 26.8 24.1172 26.8 23.275C26.8 22.4328 26.1172 21.75 25.275 21.75C24.4328 21.75 23.75 22.4328 23.75 23.275C23.75 24.1172 24.4328 24.8 25.275 24.8Z"
      fill="#FCD385"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M21.5 27.5H29L28.5 39H22.5L21.5 27.5Z" fill="#B5D0EE" />
    <path
      d="M21.9142 39.2226C21.9142 39.2226 23.1122 28.3452 19.8801 25.9155C16.648 23.4858 11.3486 27.8214 11.3486 27.8214"
      fill="white"
    />
    <path
      d="M21.9142 39.2226C21.9142 39.2226 23.1122 28.3452 19.8801 25.9155C16.648 23.4858 11.3486 27.8214 11.3486 27.8214"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M38.6707 27.502C38.6707 27.502 33.7132 23.6886 30.5482 26.0746C27.3833 28.4607 28.7053 38.4221 28.7053 38.4221"
      fill="white"
    />
    <path
      d="M38.6707 27.502C38.6707 27.502 33.7132 23.6886 30.5482 26.0746C27.3833 28.4607 28.7053 38.4221 28.7053 38.4221"
      stroke="#333333"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default DrivingIcon;
